<template>
  <van-cell-group class="UPhone">
      <van-field
        class="inputBar"
        v-model="phone"
        label="手机号"
        required
        placeholder="请输入手机号"
        :error-message="phoneValidateText"
        :blur="PhoneValidate"
      />
    <van-col span="24" type="flex" justify="space-between" class="barBtn">
      <van-button round type="danger" size="large" class="saveBth" @click.prevent="UpdateInfo">保存</van-button>
    </van-col>
  </van-cell-group>
</template>

<script>
  import { Toast } from 'vant'
  import { updatePhone } from '../../api'
  export default {
    name:"updatephone",
    data () {
      return {
        userId:'',
        phone:'',
        phoneValidateText:'',
        code:'',
        codeValidateText:'',
        validCode:''
      }
    },
    created(){
      this.userId = this.$cookies.get('userInfo').userId
	  this.phone = this.$cookies.get('userInfo').telePhone
    },
    computed: {
      isPhone () {
        return /^1\d{10}$/.test(this.phone)
      },
    },
    methods:{
      PhoneValidate () {
        if(this.isPhone){
          this.phoneValidateText = '';
          return true
        }else{
          this.phoneValidateText = '请输入正确手机号!';
          return false
        }
      },
      CodeValidate () {
        if(!/^\d{4}$/.test(this.code)){
          //验证码不对
          this.codeValidateText = '验证码不正确！';
          return false
        }else{
          if(this.code!=this.validCode){
            this.codeValidateText = '验证码不正确！';
            return false
          }else{
            this.codeValidateText = '';
            return true
          }
        }
      },
      //异步获取短信验证码
      async getCode () {
        //如果当前没有计时
        if(!this.computeTime){
          //启动倒计时
          this.computeTime = 60
          const interval = setInterval(() => {
            this.computeTime--
            if(this.computeTime<=0){
              //停止计时
              clearInterval(interval)
            }
          },1000)
          //发送ajax请求（向指定手机号发送验证码短信）
          let SendCode = {
            telephone:this.phone
          }
          // 获取短信验证
          await reqSendCode(SendCode).then(res => {
            if(res.success){
              this.validCode = res.data.validCode;
              Toast.success({message:'发送成功！',className:'apiLoading'});
            }else {
              Toast.fail({message:res.msg,className:'apiLoading'});
            }
          })
        }
      },
      UpdateInfo () {
        let _that = this
        let isPhone = this.PhoneValidate()
        if(isPhone){
          let InfoData={
            userId:this.userId,
            telephone:this.phone
          }
          updatePhone(InfoData).then(res => {
            if(res.success){
              this.$cookies.remove('userInfo');
              this.$cookies.set('userInfo',res.data);
              Toast.success({message:'保存成功！',className:'apiLoading',onClose:function(){
                  _that.$router.push({
                    path:'/profile',
                    name:'profile'
                  })
                }});
            }else {
              Toast.fail({message:'服务暂停！',className:'apiLoading'});
            }
          })
        }
      },
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus">
  @import "../../common/stylus/mixins.styl"
  .UPhone
    background #f9f9f9
    .inputBar
      font-size 26px
      border-bottom 1px solid #f9f9f9
    .van-field__label
      width 150px
      height 98px
      line-height 98px
      padding-left 10px
    .van-field__body
      line-height 98px
    .van-cell--required::before
      line-height 98px
      font-size: 28px!important
    .van-field__error-message
      font-size: 22px
      padding-bottom 10px
    .van-button--small
      width 130px
      height 55px
      font-size 20px
      border-radius 5px
    .barBtn
      padding 20% 40px 0px
      .saveBth
        color #ffffff
        font-size 32px
        background #ff6d02
        height 88px
        margin-top 100px
        line-height 88px
</style>



// WEBPACK FOOTER //
// src/pages/Settings/UpdatePhone.vue